import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

export const fetchUahConfig = async () => {
  const response = await apiService.makeRequest('/api/uah1/')
  if (!response.uah) throw new Error('Invalid response format: uah config not found')
  return { ...response.uah, promo: response.promo || null }
}

export const fetchUahPackages = async () => {
  const response = await apiService.makeRequest('/api/topup/')
  if (!Array.isArray(response.topup)) throw new Error('Invalid response format: topup array not found')
  return response.topup.filter((pkg) => pkg.uah1 !== undefined)
}

const createUahPayment = async (body) => {
  const amount = Object.values(body)[0]
  if (!Number.isSafeInteger(amount) || amount <= 0) throw new Error('INVALID_AMOUNT')
  try {
    const response = await apiService.makeRequest('/api/uah1/', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (response?.error) throw new Error(response.error)
    if (!response?.link) throw new Error('Invalid response format: link not found')
    return { link: response.link }
  } catch (error) {
    if (error.message === 'error sum') throw new Error('INVALID_AMOUNT')
    if (error.message === 'error limit') throw new Error('LIMIT_ORDER')
    if (error.message === 'error backend') throw new Error(error.status === 400 ? 'INVALID_REQUEST' : 'BACKEND_ERROR')
    throw error
  }
}

export const createPaymentByUah = (uah) => createUahPayment({ uah })
export const createPaymentByCrystals = (crystals) => createUahPayment({ crystal: crystals })
export const openUahPayment = (link, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(link, onRedirect, 'UAH', paymentWindow)
}

export default {
  fetchUahConfig,
  fetchUahPackages,
  createPaymentByUah,
  createPaymentByCrystals,
  openUahPayment
}
